var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBell = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24.881,
    height: 31.721,
    viewBox: "0 0 24.881 31.721",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bell",
    d: "M77.8,25.01a4.884,4.884,0,0,1-1.486-2.021,23.389,23.389,0,0,1-1.548-9.241v-.034a8.916,8.916,0,0,0-5.251-8.089V3.5a3.5,3.5,0,0,0-3.5-3.5h-.291a3.5,3.5,0,0,0-3.5,3.5V5.63a8.916,8.916,0,0,0-5.245,8.125A23.389,23.389,0,0,1,55.436,23a4.884,4.884,0,0,1-1.486,2.021.9.9,0,0,0-.493,1.018.937.937,0,0,0,.926.717h6.752a4.747,4.747,0,1,0,9.484,0h6.744a.937.937,0,0,0,.926-.717.9.9,0,0,0-.489-1.019ZM64.074,3.5a1.657,1.657,0,0,1,1.664-1.657h.291A1.657,1.657,0,0,1,67.684,3.5V5.033a8.916,8.916,0,0,0-3.6,0V3.5Zm1.791,26.086a2.906,2.906,0,0,1-2.895-2.832h5.8a2.906,2.906,0,0,1-2.895,2.838Zm3.705-4.681H56.486a9.66,9.66,0,0,0,.484-.848,23.319,23.319,0,0,0,1.862-10.305,7.05,7.05,0,1,1,14.1,0v.024a23.274,23.274,0,0,0,1.862,10.272,9.665,9.665,0,0,0,.484.848Z",
    transform: "translate(-53.433)",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBell, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bell.0d0771b2.svg";
export { ForwardRef as ReactComponent };